import { useEffect, useState, useRef } from 'react'

function useHover(customRef) {
  const [value, setValue] = useState(false)
  const internalRef = useRef(null)

  const ref = customRef || internalRef

  const handleMouseOver = (e) => {
    e.stopPropagation()
    e.preventDefault()
    setValue(true)
  }
  const handleMouseOut = (e) => {
    e.stopPropagation()
    e.preventDefault()
    setValue(false)
  }

  useEffect(
    () => {
      const node = ref.current
      if (node) {
        node.addEventListener('mouseover', handleMouseOver)
        node.addEventListener('mouseout', handleMouseOut)

        return () => {
          node.removeEventListener('mouseover', handleMouseOver)
          node.removeEventListener('mouseout', handleMouseOut)
        }
      }
    },
    [ref.current] // Recall only if ref changes
  )

  return [ref, value]
}

export default useHover
